import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Icon from '~/components/Icon/Icon';

import { mainStore } from '~/stores';

import styles from './HeaderOrders.module.scss';

const SeeAllButton = ({
  label,
  link,
  observerKey,
  className,
}: {
  label: string;
  link: string;
  observerKey: string;
  className?: string;
}) => {
  const { t } = useTranslation();

  const close = () => {
    mainStore.setHeaderDropdownOpen(observerKey, false);
  };

  return (
    <Link
      to={link}
      className={classes([styles.seeAllOrders, className])}
      onClick={close}
    >
      {t(label)}
      <Icon type="chevron-right" size={16} />
    </Link>
  );
};

export default observer(SeeAllButton);
